///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Route } from '@angular/router';
import { PasswordResetInitComponent } from './password-reset-init.component';

export const passwordResetInitRoute: Route = {
    path: 'reset/request',
    component: PasswordResetInitComponent,
    data: {
        authorities: [],
        pageTitle: 'global.menu.account.password'
    },
    title: 'Password'
};
